// import  { useState } from "react";

// export function SelectOptions({ level, options }) {

//   if (level == "") {
//     level = options[0]
//   }

//   const filteredOptions = options.filter(option => option !== level);

//   return (
//     <>
//       <option value={level?.toUpperCase()}>{level?.toUpperCase()}</option>
//       {filteredOptions.map(option => (
//         <option key={option} value={option}>{option}</option>
//       ))}
//     </>
//   );
// }

import React from 'react';
import './selectInput.scss';

export function SelectOptions({ level, options }) {
  const defaultLevel = level || options[0];

  const filteredOptions = options
    ? options.filter(
        (option) => option.toLowerCase() !== defaultLevel.toLowerCase()
      )
    : [];

  return (
    <>
      {defaultLevel && (
        <option value={defaultLevel} className='select-option'>
          {defaultLevel}
        </option>
      )}
      {filteredOptions.map((option) => (
        <option key={option} value={option} className='select-option'>
          {option}
        </option>
      ))}
    </>
  );
}
